(function ($, Drupal) {
  'use strict';

  $(document).ready(function () {
    $('.slick-slider').slick({});

    $('.gallery-slider').slick({}).slick('slickPause');
    $('.gallery-figcaption').slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      adaptiveHeight: false,
      fade: true,
      arrows: false
    });

    $('.gallery-slider').each(function () {
      const _that = $(this);
      const id = _that.attr('id')
      triggerScroll($('#' + id));
    })


    function triggerScroll(targetObj) {
      let targetName = targetObj.attr("id");
      let targetFlag = false;
      let scrollTop = $(window).scrollTop();
      let scrollBottom = scrollTop + $(window).height();
      let targetTop = targetObj.offset().top;
      let targetBottom = targetTop + targetObj.height();

      if (scrollBottom > targetTop && scrollTop < targetBottom) {
        if (!targetFlag) {
          // console.log(targetName + ' is in sight');
          targetObj.slick('slickPlay');
          targetFlag = true;
        }
      }
      else {
        // console.log(targetName + ' is not in sight');
        targetObj.slick('slickPause');
        targetFlag = false;
      }

      $(window).on('scroll', function () {
        scrollTop = $(window).scrollTop();
        scrollBottom = scrollTop + $(window).height();
        targetTop = targetObj.offset().top;
        targetBottom = targetTop + targetObj.height();
        if (scrollBottom > targetTop && scrollTop < targetBottom) {
          if (!targetFlag) {
            // console.log(targetName + ' is in sight');
            targetObj.slick('slickPlay');
            targetFlag = true;
          }
        }
        else {
          // Stop autoplay when you get out of the viewport
          if (targetFlag) {
            // console.log(targetName + ' is not in sight');
            targetObj.slick('slickPause');
            targetFlag = false;
          }
        }
      });
    }


  });

})(jQuery, Drupal);